// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZovmM","contactNameText":"styles_contactNameText__sTU02","icon":"styles_icon__T618Y"};